module.exports = __webpack_public_path__ + "static/media/image_light.f5e2766b.svg";